export default __webpack_public_path__ + "7b463bb086f17998284335b9fffa69ec.png";